module.exports = __webpack_public_path__ + "static/Telework_614-808cdd73aac8f4a3cf754dd5a7fa5339.png";